import dayjs from "dayjs";

export function unixTimestamp(timestamp) {
  if (!timestamp) return "-";
  timestamp = Number(timestamp);
  const date = new Date(timestamp);
  const Y = date.getFullYear();
  const M =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;
  const D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  const h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  const m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  const s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  return `${Y}-${M}-${D}  ${h}:${m}:${s}`;
}

/**
 * @param timestamp 格式化时间戳到日期
 */
export function formateDate(timestamp) {
  return dayjs(timestamp).format("YYYY-MM-DD");
}
